{
 "note": "made by tools/make-poster-sprites.py from assets/posters/raw/poster-sheet.png; do not edit",
 "image": "/sprites/posters.png",
 "widthM": 0.9,
 "about": "hand-held placards for the bazaar (data/story/s1e1.bazaar.json) and the crowd (castOf in people.ts). text is the slogan in English, for the bazaar's pick list and for anyone reading the atlas, not for in-game rendering.",
 "dropped": {
  "nta-must-go": "names NTA",
  "error-404-nta": "names NTA (\"NTA Edition\")",
  "panvel-bus": "names Panvel: a specific real-incident reference",
  "nta-still-in-charge": "names NTA"
 },
 "posters": {
  "aura-resign": {
   "x": 0,
   "y": 0,
   "w": 168,
   "h": 184,
   "text": "Aura: -10000000. Resign already."
  },
  "beta-testers": {
   "x": 170,
   "y": 0,
   "w": 168,
   "h": 165,
   "text": "Students are not beta testers for your exams."
  },
  "bro-still-employed": {
   "x": 340,
   "y": 0,
   "w": 168,
   "h": 143,
   "text": "Bro is still employed. Resign now."
  },
  "degrees-for-sale": {
   "x": 510,
   "y": 0,
   "w": 168,
   "h": 168,
   "text": "Degrees shouldn't be for sale."
  },
  "delulu-solulu": {
   "x": 680,
   "y": 0,
   "w": 168,
   "h": 184,
   "text": "Delulu is not the solulu. Exam security was a joke."
  },
  "education-not-business": {
   "x": 850,
   "y": 0,
   "w": 168,
   "h": 165,
   "text": "Education not a business."
  },
  "gpa-ghosted": {
   "x": 0,
   "y": 186,
   "w": 168,
   "h": 191,
   "text": "My GPA has been ghosted by the system."
  },
  "knowledge-not-connections": {
   "x": 170,
   "y": 186,
   "w": 168,
   "h": 183,
   "text": "Exams should test knowledge, not connections."
  },
  "leaked-exam-winter": {
   "x": 340,
   "y": 186,
   "w": 168,
   "h": 140,
   "text": "This is not a brat summer, this is a leaked exam winter."
  },
  "leaks-grace-marks": {
   "x": 510,
   "y": 186,
   "w": 168,
   "h": 165,
   "text": "Leaks today, grace marks tomorrow, what next?"
  },
  "leaks-scams-reexams": {
   "x": 680,
   "y": 186,
   "w": 168,
   "h": 83,
   "text": "Leaks, scams, grace marks, re-exams, mental health crisis, and still no resignation?"
  },
  "merit-telegram": {
   "x": 850,
   "y": 186,
   "w": 168,
   "h": 191,
   "text": "Merit? More like Telegram rit."
  },
  "pilot-project": {
   "x": 0,
   "y": 379,
   "w": 168,
   "h": 87,
   "text": "Our future is not a pilot project."
  },
  "responsibility-loading": {
   "x": 170,
   "y": 379,
   "w": 168,
   "h": 96,
   "text": "Education ministry: responsibility loading, still pending."
  },
  "same-paper-leaks": {
   "x": 340,
   "y": 379,
   "w": 168,
   "h": 191,
   "text": "Same paper, same leaks, same excuses, same minister."
  },
  "students-not-stats": {
   "x": 510,
   "y": 379,
   "w": 168,
   "h": 101,
   "text": "#StudentsNotStats: we are more than a number."
  }
 }
}